import { getMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_CONTRACT_FILE = 'GET_CONTRACT_FILE';
export const GET_CONTRACT_FILE_SUCCESS = 'GET_CONTRACT_FILE_SUCCESS';
export const GET_CONTRACT_FILE_FAILURE = 'GET_CONTRACT_FILE_FAILURE';

// Action Creators
export const getContractFileRequest = () => ({
  type: GET_CONTRACT_FILE,
});

export const getContractFileSuccess = (users) => ({
  type: GET_CONTRACT_FILE_SUCCESS,
  payload: users,
});

export const getContractFileFailure = (error) => ({
  type: GET_CONTRACT_FILE_FAILURE,
  payload: error,
});

// Thunk Function
export const getContractFileCallAPI = (external, value) => {
  return async (dispatch) => {
    dispatch(getContractFileRequest());
    try {
      const response = await getMethod(
        url?.contractFile + `?title_id=${value}`
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getContractFileSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getContractFileFailure(error?.message));
    }
  };
};
